export const RETAIL_PLATFORM = "retail";
export const FNB_PLATFORM = "fnb";
export const BOOKING_PLATFORM = "booking";
export const BOOKING_HOTEL_PLATFORM = "hotel";
export const WEBORDER = "weborder";

export const IMAGE_GENERAL_ONBOARDING =
  "https://vqnloefnaxobj.vcdn.cloud/admin_merchant/onboarding/retail-onboarding.png";
export const IMAGE_BOOKING_ONBOARDING =
  "https://vqnloefnaxobj.vcdn.cloud/admin_merchant/onboarding/booking-onboarding.png";
export const IMAGE_BOOKING_HOTEL_ONBOARDING =
  "https://vqnloefnaxobj.vcdn.cloud/admin_merchant/onboarding/hotel-onboarding.png";

export const STEP_INTRO = 1;
export const STEP_NAME = 2;
export const STEP_THEME = 3;
export const STEP_MIGRATE = 4;
export const STEP_DONE = 5;
export const KVRID_HOTEL = 17;

export enum ThemeType {
  WEBORDER = "weborder",
  EMENU = "fnb",
}

export const BRAND_TYPE_KEIVI = 'Keivi'

export const PAGE_DEFAULT_LAYOUT = "homepage";
export const PREFIX_URL_PAGE_CUSTOM = "page";

export const ERROR_MAX_THEME_ADDED = "maximum_number";
export const ERROR_THEME_NOT_FOUND = "theme_not_found";
export const ERROR_THEME_ALREADY_EXISTS = "already_exists";
export const STORAGE_THEME_CARD_ID = 'list-draft-theme'
